// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1SHzW","colMaxWidth":"Table_colMaxWidth__Ocmsv"};